<template>
	<div class="tl-header">
		<v-toolbar 
			flat 
			dark
			:color="styleHeaderColor"
			height="59px"
		>
			<v-btn 
				flat 
				large 
				class="btn-back ma-0 pa-0" 
				v-on:click="onClickBack"
				v-if="!isDisplayMemberList"
			>
				<v-icon>chevron_left</v-icon>
			</v-btn>
			<v-toolbar-title class="subheading">
				<div class="name">{{ itemName }} <span v-if="isDisplayMemberList">様</span></div>
				<div class="comment" v-if="comment && isDisplayMemberList">
					<v-icon small class="white--text mr-1">message</v-icon>
					{{ comment }}
				</div>
				<div class="term-project" v-if="!isDisplayMemberList">
					{{ projectTerm[0] }}
					<span class="pl-2" v-if="remainProject">他{{ remainProject }}件</span>
				</div>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn flat class="btn-my-task ml-0 mr-1 pa-0" v-if="!isMyUser" v-on:click="onClickMoveMyPage">
				<v-icon>refresh</v-icon>
			</v-btn>
			<v-btn flat class="btn-member ml-0 mr-1 pa-0" v-on:click="showRightPaneMemberList">
				<v-icon>people</v-icon>
			</v-btn>
			<Menu />
		</v-toolbar>
	</div>
</template>

<script>
import Menu from '../Menu';

import { LIST_MODE} from '../../classes/Const';

export default {
	name: 'TLHeader',
	props: [
		"items",
		"selected_member_code",
	],
	components: {
		Menu,
	},
	methods: {
		onClickMoveMyPage: function() {
			this.$emit('move-my-page');
		},
		onClickBack: function() {
			this.$store.dispatch('list/setDisplayListTypeMember');
		},
		showRightPaneMemberList:function(){
			if (this.items === undefined || this.items === null)
				return '';
			this.$emit("show-rightpane-memberlist", {
				member_code : this.items.code,
				mode: LIST_MODE.SELECT,
			});
		},
	},
	
	computed: {
		itemName: function() {
			if (this.items === undefined || this.items === null)
				return '';
			return this.items.name;
		},
		comment: function() {
			if (this.items === undefined || this.items === null)
				return '';
			return this.items.comment;
		},
		projectTerm: function() {
			if (this.items === undefined || this.items === null)
				return '';
			if (this.isDisplayMemberList)
				return '';
			
			let schedules = new Array();
			this.items.schedules.forEach(s => {
				let begin_date = s.begin.strftimeDCL('%m月%d日');
				let begin_time = s.begin.strftimeDCL('%H:%M');
				let end_date = s.end.strftimeDCL('%m月%d日');
				let end_time = s.end.strftimeDCL('%H:%M');
				
				let show_datetime = '';
				if (s.isSingleDay)
					show_datetime = begin_date + ' ' + begin_time + ' ～ ' + end_time;
				else
					show_datetime = begin_date + ' ' + begin_time + ' ～ ' + end_time + ' ' + end_date;
					
				if (s.all_day)
					show_datetime = begin_date + ' ～ ' + end_date;
			
				schedules.push(show_datetime);
			});
			
			return schedules;
		},
		remainProject: function() {
			if (this.projectTerm.length < 2)
				return 0;
		
			return this.projectTerm.length - 1;
		},
		isMyUser: function() {
			return this.selected_member_code === this.$store.getters['loginUser'].code;
		},
		isDisplayMemberList: function() {
			return this.$store.getters['list/isDisplayMemberList'];
		},
		styleHeaderColor: function() {
			if (this.isDisplayMemberList)
				if (this.isMyUser)
					return 'primary';
				else 
					return 'indigo';
			else
				return 'deep-purple';
		},
	},
}
</script>
<style>
	.tl-header {
		position: relative;
		width: 100%;
		border-bottom: solid 1px #1976d2;
		z-index: 102;
	}
</style>
<style scoped>
	.name, .comment, .term-project {
		word-wrap: normal;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.comment, .term-project {
		font-size: 12px;
	}
	.btn-my-task, .btn-member {
		min-width: 30px !important;
	}
	.btn-back {
		min-width: 0 !important;
		height: 100%;
	}
</style>
